import { queryOptions } from '@tanstack/react-query'
import type { components } from '@/api/schema'
import type { QuoteBuilderApi } from '../api/client'
import type { QuoteLine } from '../api/types'

type Schemas = components['schemas']
export type QuoteProtectionPlans = Schemas['QbQuoteProtectionPlans']
export type EquipmentProtection = Schemas['QbEquipmentProtection']
export type ProtectionPlanOffer = Schemas['QbProtectionPlanOffer']

/** Each equipment line's Safeware plans at its quoted Sell, read again on every quote revision (USA-1162). */
export const protectionPlansQueryOptions = (api: QuoteBuilderApi, quoteId: string, revision: number) =>
  queryOptions({
    queryKey: ['protection-plans', quoteId, revision],
    queryFn: ({ signal }) => api.request<QuoteProtectionPlans>(`/quotes/${quoteId}/protection-plans`, { signal }),
    staleTime: Infinity,
    retry: false,
  })

/** `24` → "2 years", `18` → "18 months". */
export function coverageText(months: number) {
  if (months % 12) return `${months} months`
  const years = months / 12
  return years === 1 ? '1 year' : `${years} years`
}

/** A Safeware plan line on the quote (USA-1162). */
export function isPlanLine(line: QuoteLine) {
  return Boolean(line.is_warranty && line.protection_plan)
}

/** What Sales can do with plans; the Equipment stage turns each into queued quote edits. */
export type PlanActions = {
  /** Add `offer` under `equipment`, replacing `current` when given. */
  onChoosePlan: (equipment: QuoteLine, offer: ProtectionPlanOffer, current?: QuoteLine) => void
}
